// extracted by mini-css-extract-plugin
export default {"root":"AgeRangeCard_root__+GMKz","header":"AgeRangeCard_header__pMWb+","radioGroup":"AgeRangeCard_radioGroup__6Ej9z","text":"AgeRangeCard_text__LH4kE"};